<template>
	<v-card outlined style=" width:100%; height:100%; object-fit: fill;" class="pb-0">
		<template v-if="!is_local">
			<v-system-bar 
				lights-out dark class="vue-draggable-handle" v-show="!show_bar">
					
				<!-- <span  
					v-if="!show_host" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" 
					style="font-size:70%;"
				> {{id_stream}} </span>
				<span 
					v-else :class="$vuetify.theme.dark ? 'white--text' : 'black--text'" 
					style="font-size:70%;"
				> {{show_host}}
				</span>			 -->
				<span 
					:class="[$vuetify.theme.dark ? 'white--text' : 'black--text', 'justify-center']" style="font-size:70%; overflow:hidden; height: 15px;"> 
					
						{{ hostname }} 
					-
					<span
						v-show="type_analytic"
					>
							{{ type_analytic }}   -
					</span>
					<strong class="text-uppercase info--text">
						{{stream_type}}
					</strong> 

				 </span>
				<v-spacer></v-spacer>
				
				<v-tooltip
			     	top
			     	v-if="stream_type=='udp'"
			     >
			     	<template v-slot:activator="{ on }">					     		
			     		<v-icon x-small v-on="on" :color="color_message">mdi-circle</v-icon>
			     	</template>
			     	<span> {{ $ml.get('udp_connection') }}: {{status_message}}</span>
			     	<br>
			     	<span> {{ $ml.get('stream_data') }}: {{ udp_conection }}</span>
			     	<br>
			     	<span> {{ $ml.get('stream_element') }}: {{ udp_view }}</span>
			     </v-tooltip>
				<v-icon small 
					class="no-dragg primary--text mx-2"
					v-if="currentUser && currentUser.user.roleId < 3  && $router.currentRoute.name=='dashboard'"
					@click="redirect_setting"
				>
					mdi-pencil
				</v-icon>
				<v-btn x-small outlined icon color="error"
					@click="$emit('close_component', layout_id)"
					v-if="currentUser && currentUser.user.roleId < 3 "
				>
					<v-icon x-small color="error" class="ml-1" outlined>mdi-close</v-icon>
				</v-btn>
			</v-system-bar>
		</template>

		<!-- </v-card-title> -->
		<v-card-text style="width:100%; height:95%; object-fit: fill;" class="pa-0 pb-7 no-drag">

				<!-- <video autoplay muted :id="'flv'+id_stream" v-if="type=='flv'" style="width:100%; height:100%; object-fit: fill;"> 
					<!- - cover - ->
					        <source  type="video/x-flv">

				</video> -->
				<!-- <video-player v-show="stream_type=='hls'" ref="videoPlayer" 
						style="width:100%; height:100%; object-fit: fill;"					
						class="resize"
						  :options="playerOptions"
						  @play="onPlayerPlay($event)"
						  @pause="onPlayerPause($event)"
						  @ready="onPlayerReady($event)">
				</video-player> -->
				<video 
					:id="name+stream_type+'stream'+id_stream" 
					v-if="stream_type=='flv' || stream_type=='ws'"
					style="width:100%; height:100%; object-fit: fill;"
					 muted="muted"
					 @error="handleVideoError"
					 ref="videoPlayer">
				</video>

				<!-- video buffer -->

				
				<!-- <video 
					:id="'buffer'+id_stream" 
					v-show="stream_type=='event' || stream_type=='udp'"
					style="width:100%; height:100%; object-fit: fill;"
					muted="muted"
				></video> -->

				<img 
					:id="name+type+type_analytic+id_stream" 
					v-show="stream_type=='udp' || stream_type=='event'" 
					style="width:100%; height:100%; object-fit: fill;" 
					@error="handleImageError"
					:src="streamSource" 
					ref="imagePlayer">

				<!-- <img :id="name+'event'+id_stream" v-show="stream_type=='event'" style="width:100%; height:100%; object-fit: fill;" ></img> -->
				
				<img :id="name+'rstp'+id_stream" v-if="stream_type=='rstp'" style="width:100%; height:100%; object-fit: fill;" ></img>		
				<template v-if="!is_local">
					
				<v-system-bar lights-out dark style="overflow: hidden" v-show="!show_bar">
				<!-- Type Analytics  -->
				<v-menu 
					offset-y 
					top 
					:close-on-content-click="true" 
					v-if="currentUser && currentUser.user.roleId < 3 "
				>	
					 <template v-slot:activator="{ on: menu }">
						<v-tooltip top>
							<template v-slot:activator="{ on:tooltip }">					
								<v-icon 
									small 
									v-on="{...tooltip, ...menu}" 
									class="vue-draggable-handle"
								>
									mdi-eye-settings</v-icon> <!-- axis-arrow-lock -->
							</template>
							<span>
								{{$ml.get('video_stream_type')}}
							</span>
						</v-tooltip>
					</template>
					<v-list dense>
			    		<v-list-item-group dense>
			    			<template v-for="(item_stream, key, index) of list_analytics">
			    				
			    			<v-list-item 
			    				
			    				v-bind:Key="index"
			    				v-if="item_stream"
			    				dense
			    				 @click="change_analytic(item_stream.action)" 	
			    			>
			    				<!-- @click="change_streaming(item_stream.action)" -->
			    			
			    				<v-list-item-icon class="pl-0 mr-0">
					      			<v-icon small>mdi-{{item_stream.value}}</v-icon>
					      		</v-list-item-icon>
					      		<v-list-item-content class="pa-0 ma-0">
					      			<v-list-item-title>{{ item_stream.text }}</v-list-item-title>
					      		</v-list-item-content>
			    			</v-list-item>
			    			</template>
			    		</v-list-item-group>
			    	</v-list>
				</v-menu>

				<!-- Type stream -->
				<v-menu 
					offset-y 
					top 
					:close-on-content-click="true" 
					v-if="currentUser && currentUser.user.roleId < 3 "
				>	
					 <template v-slot:activator="{ on: menu }">
						<v-tooltip top>
							<template v-slot:activator="{ on:tooltip }">					
								<v-icon 
									small 
									v-on="{...tooltip, ...menu}" 
									class="vue-draggable-handle"
								>
									mdi-video</v-icon> <!-- axis-arrow-lock -->
							</template>
							<span>
								{{$ml.get('video_stream_type')}}
							</span>
						</v-tooltip>
					</template>
					<v-list dense>
			    		<v-list-item-group dense>
			    			<template v-for="(item_stream, key, index) of video_stream_types">
			    				
			    			<v-list-item 
			    				
			    				v-bind:Key="index"
			    				v-if="item_stream"
			    				dense
			    				@click="change_streaming(item_stream.action)"
			    				 
			    			>
			    			
			    				<v-list-item-icon class="pl-0 mr-0">
					      			<v-icon small>mdi-{{item_stream.value}}</v-icon>
					      		</v-list-item-icon>
					      		<v-list-item-content class="pa-0 ma-0">
					      			<v-list-item-title>{{ item_stream.text }}</v-list-item-title>
					      		</v-list-item-content>
			    			</v-list-item>
			    			</template>
			    		</v-list-item-group>
			    	</v-list>
				</v-menu>


					<v-btn x-small height="20" class="primary--text mb-1"> 
						{{$ml.get('host_id')}}: 					
						<span  v-if="!show_host"> {{id_stream}} </span> 
						<span v-else> {{show_host}}</span>
					</v-btn>
					
					
					<v-tooltip top v-if="host_ip">
						<template v-slot:activator="{ on }">
							<v-btn x-small v-on="on" class="mx-2 mb-1">
								<v-icon small color="success">mdi-ip-network</v-icon>  
								{{host_ip}}
						</v-btn>
					</template>

					{{ $ml.get('ip') }}:{{host_ip}}
					</v-tooltip>

					<v-tooltip top v-if="!host_ip">
						<template v-slot:activator="{ on }">
							<v-btn x-small v-on="on" class="mx-2 mb-1">
								<v-icon small color="success">mdi-file-video</v-icon>  
								{{id_stream}}
						</v-btn>
					</template>

					{{ $ml.get('device_id') }}
					</v-tooltip>
				<!-- <v-spacer></v-spacer> -->
			</v-system-bar>
				</template>		
				<template v-else>
					<p class="caption">
						{{id_stream}}
					</p>
				</template>
				<v-overlay :value="hasError" absolute>
					<v-alert type="error" dense>
						{{ errorMessage }}
					</v-alert>
				</v-overlay>
		</v-card-text>
		<!-- <v-card-actions></v-card-actions> -->
	</v-card>

</template>
<style scoped>
	.resize>>>.video-js{
		width:100%;
		height:100%;
		object-fit: fill;
	}
	.font_reduce_min{
		font-size:70%;
	}
	/*.resize>>>.vjs-tech{
		height:100%;
		width:100%;
		
	}*/
	/*.resize>>>.video-js>>>.vjs_video_3-dimensions{
		width:100px;
		
	}*/
	
	/*
	#vjs_video_3{
		width:100%;
		height:100%;
		object-fit: fill;	
	}
	.vue-grid-item>>>.no-dragg>>>.vjs_video_3-dimensions{
		display: flex;
		vertical-align: top;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #fff;
		background-color: #000;
		padding: 0;
		font-size: 10px;
		line-height: 1;
		font-weight: normal;
		font-style: normal;
		font-family: Arial, Helvetica, sans-serif;
		word-break: initial;
		/*position: relative;*/
		/*;inherit!important;
		width: 100%; 
		height: 100%;
		object-fit: fill;
	}*/
</style>
<script>
	// import flvjs from 'flv.js'	
	import io from 'socket.io-client';
	// import Ping from 'ping.js';
	import axios from 'axios';
	import VueGridLayout from 'vue-grid-layout';
	// import {videoPlayer} from 'vue-videojs7'
	// import 'video.js/dist/video-js.css'
	// import wjs from "wcjs-player";
	// import * as wjsPrebuilt from "wcjs-prebuilt";
	import EventBus from '@/event-bus'

	export default{
		name: 'cam',
		components:{ 			
			// flvjs, 
			// videoPlayer
		},
		props:[
			'id_stream', // ID to connect 
			'host',  
			'type',  // UDP,
			'hostname', // name cam 
			'name', // name get document
			'layout_id', 
			'host_ip', 
			'show_host', 
			'is_local',
			'info_stream', // info of cam
			'show_bar',
			'is_analytic',
		], //, 'layout', 'layout_w'
		data:() =>({
			// layout: [],
			id:'',
			playerOptions: {
				muted: true,
				autoplay: true,
				controls: true,
				// width: 200,
				// height: 145,
				controlBar: {
					timeDivider: false,
					durationDisplay: false
				}
				// poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
			},
			status_message: '',
			color_message: '',
			video_stream_types:[
				{ text: 'UDP', value: 'video-image', action: 'udp' }, //stream_
				{ text: 'EVENT', value: 'video-image', action: 'event' },
				// { text: 'stream_flv', value: 'video-box', action: 'flv' },
				// { text: 'stream_ws', value: 'video', action: 'ws' },
				// { text: 'stream_hls', value:  'video-outline', action: 'hls' }
			],
			stream_type: '',
			udp_conection: false,
			udp_view: true,
			flvPlayer: null,
			flvErrors: null,
			socket_udp: null,
			interval_flv: null,
			eventbus_active: false, // true => socket , false => eventBus
			list_analytics: [
				{ text: 'motion', value: 'video-image', action: 'motion' },
				{ text: 'objects', value: 'video-image', action: 'objects' },
			],
			type_analytic: 'motion',
			is_active_udp: false,
			buffer: null,
			hasError: false,
			errorMessage: '',
			streamSource: null,
		}),
		created(){
			this.stream_type=this.type;
			this.type_analytic = this.is_analytic;

		}, // created
		watch:{
			is_analytic: function(val){
				if (val) {
					this.type_analytic = val;
					console.log(val, 'cam type_analytic watch')
				}
			}
			// layout_w: function(){
			// 	this.render_size('width');
			// },
			// layout: function(){
			// 	this.render_size('height');
			// },
		},
		computed: {
			player () {
				// console.log(this.$refs.videoPlayer.player, 'ref player')
				return this.$refs.videoPlayer.player
			}, // player
			currentUser() {
		      // if (this.$store.state.auth.user){
		      //   // console.log(this.$store.state.auth.user, 'auth')
		      //   this.user=this.$store.state.auth.user.user.Username;
		      // }
		      return this.$store.state.auth.user;
		      //console.log(this.$store.state.auth.user.username);

		    },
			
		},
		methods:{
			onPlayerPlay (player) {
				// console.log('player play!', player)
			},
			onPlayerPause(player) {
		       // console.log('player pause!', player)
		    },
			onPlayerReady (player) {
				// console.log('player ready!', player)

				this.player.play()
			},
			playVideo: function (source, type_source) {
				const video = {
					withCredentials: false,
					type: type_source,//'application/x-mpegurl',
					src: source
				}
				this.player.reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
				this.player.src(video)
				// this.player.load()
				if (!this.is_local) {
					this.player.play()
				}
			},



			/*render_size(val){
				if (val=='width') {
					console.log(this.$refs.size_cam.clientWidth, 'width')
					this.playerOptions['width'] = this.$refs.size_cam.clientWidth;
				}else{

					this.playerOptions.height = this.$refs.size_cam.clientHeight;
				}
			},*/

			redirect_config_host(){
				// console.log('redirect', this.show_host, this.id_stream);
				// var vm=this;
				let v=this.id_stream;
				if(this.show_host){
					v=this.show_host;
				}
				this.$router.push({name: 'host_configuration', params: { id:v} });
				// }
			}, // redirect

			redirect_setting(){
				// console.log('redirect', this.show_host, this.id_stream);
				// var vm=this;
				let inf_setting = this.info_stream;
				localStorage.setItem('settings_device', JSON.stringify({ inf_setting }) );
				this.$router.push({ name: 'setting_device' });
				// }
			}, // redirect

			change_streaming(val){
			
				this.stream_type=val;
				let item_to_change={ Id: this.layout_id, new_val: val };
				console.log('item_to_change')
				this.$emit('to_streaming', item_to_change);		
				let type_stream=val, id=this.id_stream;
				if (val == 'udp') {
					this.is_active_udp = this.is_active_udp ? true : false;
				}else{
					if(this.is_active_udp){

						this.is_active_udp = false;
						EventBus.$emit('close_stream', this.id_stream)
					}
				}

				if(type_stream=='flv'){ //flv
					console.log('flv')
					let video  = document.getElementById('flv'+id);		
					//let  url = "http://"+this.$localhost+":8000/live/"+id+".flv";//host
					let src='', type_src='flv';//'application/x-mpegurl';
					src = "http://"+this.$localhost+":8000/live/"+id+".flv"
						if (this.player) {
							this.player.pause();
						}
						console.log(src, 'link flv')
					this.setup_camera('flv'+'stream'+id, src, type_src);
					// this.playVideo(src, type_src)
				} // flv
				if(type_stream=='ws'){
					console.log('ws')
					let video  = document.getElementById('ws'+id);		
					//let  url = "http://"+this.$localhost+":8000/live/"+id+".flv";//host
					let src='', type_src='flv';//'application/x-mpegurl';
					if (this.player) {
						this.player.pause();
					}
					src = "ws://"+this.$localhost+":8000/live/"+id+".flv"
					this.setup_camera('ws'+'stream'+id, src, type_src);
					// this.playVideo(src, src, type_src)
				}
				
				if (type_stream=='hls') {
					console.log('hls')
					let video  = document.getElementById('hls'+id);		
					//let  url = "http://"+this.$localhost+":8000/live/"+id+".flv";//host
					let src='', type_src='application/x-mpegurl';
					
						src = "http://"+this.$localhost+":8000/live/"+id+"_480/index.m3u8"
					
					this.playVideo(src, type_src);
				}

			}, // change streaming	

			change_analytic(item){
				console.log('type change_analytic change cam', item)
				this.type_analytic = item;
				let item_to_change={ Id: this.layout_id, new_val: item };
				this.$emit('to_analytic', item_to_change)

			}, // change_analytic

			setup_camera(element='', url, type_s='', id) {

				const urlStreaming="http://"+location.hostname+":8000/api/streams";
				axios.defaults.withCredentials = false;
				// axios.get(urlStreaming).then(response=>{
					// console.log(element, typeof element)
					console.log("In this moment flv is disabled")
					let videoElement=null;
					/*this.$nextTick( () => {
						videoElement = document.getElementById(this.name+this.stream_type+'stream'+this.id_stream);
					// if(response.data.live){
						// console.log(response)
						// if(response.data.live[''+id]){
							// if (flvjs.isSupported()) {
								this.flvPlayer =  new flvjs.createPlayer({
									type: type_s,
									url: url,
									isLive: true,
									enableWorker:true,
									autoCleanupSourceBuffer: true,
									autoCleanupMaxBackwardDuration: 2*60,
									autoCleanupMinBackwardDuration: 1*60
								});
								// console.log(videoElement, 'document')
								this.flvPlayer.attachMediaElement(videoElement);
								this.flvPlayer.load();
								this.flvPlayer.play();								
					})*/
					// this.flvErrors=flvjs.Events;
					// console.log(this.flvErrors, 'errors flv')
							// }
						// }
					// }
				// })

			
					// console.log(flvjs.Events, flvjs.ErrorTypes, 'error flv')
				

			}, // setup camera

			cleanupResources() {
				// Cleanup socket connection
				if (this.socket_udp) {
					this.socket_udp.disconnect();
					this.socket_udp = null;
				}

				// Cleanup video elements
				const videoElement = document.getElementById(this.name + this.stream_type + 'stream' + this.id_stream);
				if (videoElement) {
					videoElement.pause();
					videoElement.src = '';
					videoElement.load();
				}

				// Clear any running intervals
				if (this.interval_flv) {
					clearInterval(this.interval_flv);
					this.interval_flv = null;
				}

				// Clear any event listeners
				if (this.eventbus_active) {
					EventBus.$off('stream_' + this.id_stream);
				}
			},

			handleVideoError(event) {
				console.error('Video error:', event);
				this.hasError = true;
				this.errorMessage = 'An error occurred while playing the video. Please try again later.';
			},

			handleImageError(event) {
				console.error('Image error:', event);
				this.hasError = true;
				this.errorMessage = 'An error occurred while loading the image. Please try again later.';
			},

		}, // methods
	
		mounted(){
			 
			    // console.log(viewer1, 'element1')
			// this.img1=document.getElementById(id)
			let id=this.id_stream; // host id
			// console.log(id, this.id, this.host, this.type)
			// var num=this.device_id;
			let host=this.host;
			let type_stream=this.type;
			// this.change_streaming(type_stream);
			// console.log('cam data',host, type_stream, id)
			EventBus.$emit('start_stream', id);


			let bf = this;
			let vw = this;

			// Video 
			
				/*let mime = 'video/mp4; codecs="avc1.4D0029"';
	            if (!MediaSource.isTypeSupported(mime)) {
	                alert('Unsupported mime type');
	                return;
	            }
	            // let buffer;
	            let socket;
	            let video = document.getElementById('buffer'+id);

	            console.log(video, 'exist tag');
	            let mediaSource = new MediaSource();
	            video.src = URL.createObjectURL(mediaSource);
	            mediaSource.addEventListener('sourceended', function(e) {
	                console.log('sourceended: ' + mediaSource.readyState);
	            });
	            mediaSource.addEventListener('sourceclose', function(e) {
	                console.log('sourceclose: ' + mediaSource.readyState);
	                //todo remove( buffer = mediaSource.addSourceBuffer(mime))
	            });
	            mediaSource.addEventListener('error', function(e) {
	                console.log('error: ' + mediaSource.readyState);
	            });
	            mediaSource.addEventListener('sourceopen', function(e) {
	                console.log('sourceopen: ' + mediaSource.readyState);
	                bf.buffer = mediaSource.addSourceBuffer(mime);
	                bf.buffer.mode = 'sequence';
	                bf.buffer.addEventListener('update', function(e) {
	                    console.log('update');
	                });
	                bf.buffer.addEventListener('updateend', function(e) {
	                    console.log('updateend');
	                    //hack to get safari on mac to start playing, video.currentTime gets stuck on 0
	                    if (mediaSource.duration !== Number.POSITIVE_INFINITY && video.currentTime === 0 && mediaSource.duration > 0) {
	                        video.currentTime = mediaSource.duration - 1;
	                        mediaSource.duration = Number.POSITIVE_INFINITY;
	                    }
	                    video.play();
	                });
	            })*/
			
	            /* *************************** Stream Event : OPTION **************************** */
				let viewer = document.getElementById(this.name+this.type+this.type_analytic+this.id_stream);
				EventBus.$on('motion_event', (msg) => {
					
					viewer.onload = function () {
			          viewer.src=msg.evidence;
			        }
			        viewer.src=msg.evidence;


					/*let type_analytics = vw.type_analytic;
					let dt = msg;
					var data = new Uint8Array(msg.data);
					console.log(data, 'Uint8Array');
        			bf.buffer.appendBuffer(data);*/
				})

		}, //mounted

		beforeDestroy(){
			this.cleanupResources();
		},
		deactivated() {
			this.cleanupResources();
		}
	};
</script>